<template lang="pug">
    .newsletter.full-height-error.not-valid(v-if="!enabledExtensions.includes('newsletter')")
        Error(:message="null" :code="403")
    .newsletter.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    .newsletter.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .newsletter(v-else)
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                el-tooltip(v-if="! loading && isDeletable && ! hasBeenSent" class="item" effect="dark" :content="$t('Delete')" placement="top")
                    el-button.delete-button(
                        circle
                        type="danger"
                        icon="el-icon-fa-trash-alt far"
                        :loading="deleting"
                        :disabled="isDisabledSubmit && ! deleting"
                        @click="deleteCurrentNewsletter"
                    )
                el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="top")
                    el-button(
                        circle icon="el-icon-fa-times fas"
                        :disabled="isDisabledSubmit && ! hasBeenSent"
                        @click="leave"
                    )
                el-tooltip(v-if="! loading && ! hasBeenSent" class="item" effect="dark" :content="$t('Save and close')" placement="top")
                    el-button(
                        circle
                        type="primary"
                        icon="el-icon-fa-check fas"
                        :disabled="isDisabledSubmit && ! savingAndClose"
                        :loading="savingAndClose"
                        @click="submit($event, listRoute)"
                    )
                el-tooltip(v-if="! loading && ! hasBeenSent" class="item" effect="dark" :content="$t('Save')" placement="top")
                    el-button(
                        circle
                        type="success"
                        icon="el-icon-fa-save fas"
                        :disabled="isDisabledSubmit && ! saving"
                        :loading="saving"
                        @click="submit"
                    )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            all-input-fields
            el-card(shadow="always" v-loading="loading")
                transition(name="slide-decent-vertical")
                    .status-logs-container.z-depth-1(v-if="logs.length")
                        .spinner-container(v-if="loadingLogs")
                            .spinner
                        StatusLog(v-for="log in logs" :key="log.id" :log="log")
                            template(v-if="['success', 'error'].includes(log.status)" slot="actions")
                                a.is-danger(href="#" @click.prevent="hideStatusLog(log)")
                                    i.el-icon-fa-times.fas

                router-view.newsletter-form(:key="$route.path" :class="{'loading-panel': loading}")
            .buttons-flex
                .form-buttons
                    el-button.preview-button(
                        round plain
                        v-if="!!id && ! hasBeenSent"
                        type="link"
                        icon="el-icon-fa-eye far"
                        :disabled="isDisabledSubmit"
                        @click="showPreviewModal"
                    )
                        | {{ $t('Preview') }}
                        kbd.shortcut-hint {{ previewShortcut }}
                    el-button(
                        round
                        v-if="canBeSent"
                        type="success"
                        icon="el-icon-fa-paper-plane far"
                        :disabled="isDisabledSubmit"
                        @click="showSendModal"
                    ) {{ $t('Send') }}
                .form-buttons
                    el-button(
                        round v-if="! loading"
                        icon="el-icon-fa-times fas"
                        :disabled="isDisabledSubmit && ! hasBeenSent"
                        @click="leave"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        round v-if="! loading && ! hasBeenSent"
                        type="primary"
                        icon="el-icon-fa-check fas"
                        :loading="savingAndClose"
                        :disabled="isDisabledSubmit && ! savingAndClose"
                        @click="submit($event, listRoute)"
                    ) {{ $t('Save and close') }}
                    el-button(
                        round v-if="! loading && ! hasBeenSent"
                        type="success"
                        icon="el-icon-fa-save fas"
                        :loading="saving"
                        :disabled="isDisabledSubmit && ! saving"
                        @click="submit"
                    ) {{ $t('Save') }}

        el-drawer.email(
            :title="previewDrawer.title"
            :visible.sync="previewDrawer.visibility"
            :close-on-press-escape="true"
            :wrapper-closable="true"
            :modal="true"
            :size="previewDrawer.size"
            :class="previewDrawer.context"
            @closed="resetPreviewModal"
        )
            el-form(v-loading="previewDrawer.loading")
                template(v-if="previewDrawer.error === false")
                    transition(name="slide-decent-vertical")
                        .meta(v-if="previewDrawer.loading === false && previewDrawer.data")
                            .from-to
                                .from
                                    b {{ $t('From') }}:
                                    span.pill {{ previewDrawer.data.sender }}
                                .to
                                    b {{ $t('To') }}:
                                    span.pill(v-for="to in previewDrawer.data.recipients") {{ to }}
                            .subject
                                b {{ $t('Subject') }}:
                                span {{ previewDrawer.data.subject }}
                            //- .attachments(v-if="previewDrawer.data.attachments && previewDrawer.data.attachments.length")
                            //-     b(v-if="previewDrawer.data.attachments.length > 1") {{ $t('Attachments') }}
                            //-     b(v-else) {{ $t('Attachment') }}
                            //-     ul
                            //-         li(v-for="attachment in previewDrawer.data.attachments")
                            //-             a(href @click.prevent="previewModalAttachment(attachment)") {{ attachment.name }}
                    section.body
                        iframe(
                            v-show="previewDrawer.data"
                            ref="preview-iframe"
                            frameBorder="0"
                            @load="previewLoaded"
                            @error="previewError"
                        )
            //- .drawer-footer
            //-     el-button(
            //-         round
            //-         size="mini"
            //-         icon="el-icon-fa-times fas"
            //-         @click="closePreviewModal"
            //-     ) {{ $t('Dismiss') }}

        el-dialog.send-dialog(
            :title="$t('Send Newsletter')"
            :visible.sync="sendModal.visibility"
            :before-close="confirmDiscard(() => changedSince(sendModal.formSnapshot, sendModal.form))"
            :close-on-click-modal="false"
            top="10vh"
            width="760px"
            @closed="resetSendModal"
        )
            el-form.filter-modal-form(
                ref="sendModal"
                :model="sendModal.form"
                label-position="top"
                :rules="sendModalRules"
                v-loading="sendModal.loading"
                @submit.prevent.native="sendNewsletter"
            )
                transition(name="slide-vertical")
                    .modal-body(v-if="! sendModal.loading")
                        .flex-row
                            el-form-item(:label="$t('Mode')" prop="mode")
                                el-radio-group(v-model="sendModal.form.mode")
                                    el-radio-button(key="test" value="test" label="test") {{ $t('Test Mode') }}
                                    el-radio-button(key="production" value="production" label="production") {{ $t('Live Mode') }}
                            transition(name="slide-decent-vertical")
                                el-form-item(v-if="sendModal.form.mode === 'production'" :label="$t('Timing')" prop="timing")
                                    el-radio-group(v-model="sendModal.form.timing")
                                        el-radio-button(key="immediate" value="immediate" label="immediate") {{ $t('Immediate') }}
                                        el-radio-button(key="scheduled" value="scheduled" label="scheduled") {{ $t('Scheduled') }}
                            transition(name="slide-decent-vertical")
                                el-form-item.grow(v-if="sendModal.form.mode === 'production' && sendModal.form.timing === 'scheduled'" :label="$t('Scheduled At')" prop="scheduled_at")
                                    //- value-format="YYYY-MM-DD HH:mm:ss"
                                    //- :format="$t('yyyy-MM-dd') + ' HH:mm'"
                                    el-date-picker.is-full-width(
                                        v-model="sendModalScheduledAt"
                                        type="datetime"
                                        :placeholder="$t('Select date and time')"
                                        :format="$t('yyyy-MM-dd') + '   HH:mm'"
                                        :default-time="'12:00:00'"
                                        prefix-icon="far el-icon-fa-calendar-alt"
                                        :picker-options="{ disabledDate(time) { return time.getTime() < Date.now() - 86400000; } }"
                                        :editable="false"
                                        :clearable="false"
                                    )
                        transition(name="slide-decent-vertical")
                            el-form-item(v-if="sendModal.form.mode === 'test'" :label="$t('Test Email Addresses')" prop="testRecipients")
                                el-select.is-full-width(
                                    v-model="sendModal.form.testRecipients"
                                    multiple
                                    filterable
                                    allow-create
                                    default-first-option
                                    :placeholder="$t('Enter email addresses...')"
                                )
                        transition(name="slide-decent-vertical")
                            el-form-item.no-margin(v-if="sendModal.form.mode === 'test'" :label="$t('Personalization Member')")
                                el-autocomplete.is-full-width(
                                    v-model="sendModal.form.testMemberSearch"
                                    value-key="name"
                                    :fetch-suggestions="autocompleteMember"
                                    :placeholder="$t('Search member...')"
                                    @select="selectTestMember"
                                    @clear="clearTestMember"
                                    clearable
                                )
                                    template(slot-scope="{ item }")
                                        .autocomplete-item
                                            b.name {{ item.name }}
                                            .email {{ item.email }}
                                .test-member-hint {{ $t('Optional: Select a member for Twig personalization (name, salutation, etc.)') }}
                        transition(name="slide-decent-vertical")
                            el-form-item(v-if="sendModal.form.mode === 'production'" :label="$t('Sender Name')" prop="customSenderName")
                                el-input(
                                    v-model="sendModal.form.customSenderName"
                                    :placeholder="$t('Sender display name')"
                                    maxlength="255"
                                )
                        transition(name="slide-decent-vertical")
                            el-form-item(v-if="sendModal.form.mode === 'production'" :label="$t('Sender Email')" prop="customSenderAddressLocalPart")
                                el-input(
                                    v-model="sendModal.form.customSenderAddressLocalPart"
                                    :placeholder="$t('Local part')"
                                    maxlength="64"
                                )
                                    template(slot="append") {{ '@' + senderEmailDomain }}
            template(slot="footer")
                .flex-row
                    el-button(
                        :disabled="sendModal.sending"
                        icon="el-icon-fa-times fas"
                        @click="closeSendModal"
                    ) {{ $t('Dismiss') }}
                    .grow
                    el-button(
                        :disabled="sendModal.loading"
                        :loading="sendModal.sending"
                        :type="sendModal.form.mode === 'test' ? 'primary' : 'success'"
                        icon="el-icon-fa-paper-plane fas"
                        @click="sendNewsletter"
                    )
                        span(v-if="sendModal.form.mode === 'test'") {{ $t('Send Test Email') }}
                        span(v-else) {{ $t('Send Newsletter') }}
</template>

<i18n>
{
    "de": {
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Newsletter could not be fetched.": "Newsletter konnte nicht gefunden werden.",
        "Newsletter could not be deleted.": "Newsletter konnte nicht gelöscht werden.",
        "Newsletter deleted successfully!": "Newsletter erfolgreich gelöscht!",
        "Newsletter could not be saved.": "Newsletter konnte nicht gespeichert werden.",
        "Newsletter saved successfully!": "Newsletter erfolgreich gespeichert!",
        "Newsletter Not Found": "Newsletter nicht gefunden",
        "Newsletter will be sent asynchronously": "Newsletter wird asynchron gesendet",
        "Newsletter could not be queued.": "Newsletter konnte nicht angereiht werden.",
        "planned": "Geplant",
        "Planned for": "Geplant für",
        "Cancel Schedule": "Zeitplan abbrechen",
        "Change Schedule": "Zeitplan ändern",
        "Schedule cancelled successfully": "Zeitplan erfolgreich abgebrochen",
        "Failed to cancel schedule": "Zeitplan konnte nicht abgebrochen werden",
        "Schedule updated successfully": "Zeitplan erfolgreich aktualisiert",
        "Failed to update schedule": "Zeitplan konnte nicht aktualisiert werden",
        "Send": "Senden",
        "Mode": "Modus",
        "Timing": "Zeitpunkt",
        "Immediate": "Sofort",
        "Scheduled": "Später",
        "Test Mode": "Testmodus",
        "Live Mode": "Live-Modus",
        "Scheduled At": "Geplant für",
        "Test Email Address": "Test-E-Mail-Adresse",
        "Personalization Member": "Personalisierungs-Mitglied",
        "Search member...": "Mitglied suchen...",
        "Optional: Select a member for Twig personalization (name, salutation, etc.)": "Optional: Wählen Sie ein Mitglied für die Twig-Personalisierung (Name, Anrede, etc.)",
        "Select date and time": "Datum und Uhrzeit auswählen",
        "Send Test Email": "Test-E-Mail senden",
        "Send Newsletter": "Newsletter versenden",
        "Email preview": "Email vorschau",
        "From": "Von",
        "To": "An",
        "Cc": "Cc",
        "Bcc": "Bcc",
        "Subject": "Betreff",
        "Preview": "Vorschau",
        "Preview could not be rendered": "Vorschau konnte nicht generiert werden",
        "Newsletter": "Newsletter",
        "Recipients & Schedule": "Versand",
        "Settings": "Einstellungen"
    }
}
</i18n>

<script>
import { isApplePlatform } from '@/helpers/shortcuts';
import _ from 'lodash';
import echo from '@/echo';

import { getUnixTime, fromUnixTime } from 'date-fns'
import { appFromUnixTime, appGetUnixTime } from '@/utils/timezone'
import { isNumeric, checkRestrictions } from '@/helpers'

import store from '@/store';
import router from '@/router';
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, usePageStore, useNewsletterNewsletterStore } from '@/stores'

import StatusLogApi from '@/store/api/system/statusLog';
import MemberApi from '@/extensions/restrictedArea/store/api/member';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import StatusLog from '@/views/cms/Dashboard/widgets/logs/Partials/StatusLog';

// validate all fields, regardless if the corresponding component is mounted or not
import AllInputFields from './AllInputFields';
import discardGuard from '@/mixins/discardGuard';

export default {
    name: 'Newsletter',
    mixins: [discardGuard],
    data() {
        return {
            previewDrawer: {
                visibility: false,
                size: '700px',
                title: this.$t('Preview'),
                loading: false,
                error: false,
            },
            sendModal: {
                visibility: false,
                size: '500px',
                title: this.$t('Send Newsletter'),
                form: {
                    mode: 'test', // possible values: 'test', 'production'
                    timing: 'immediate', // possible values: 'immediate', 'scheduled'
                    scheduled_at: null,
                    testRecipients: [_.get(this.user, 'email') || _.get(this.activeCms, 'owner.user.email')],
                    testMemberSearch: '',
                    testMemberId: null,
                    customSenderName: '',
                    customSenderAddressLocalPart: ''
                },
                formSnapshot: undefined,
                loading: false,
                sending: false,
                error: false,
            },

            listRoute: { name: 'newsletters' },
            error: false,
            pathNotValid: false,
            loading: false,
            saving: false,
            savingAndClose: false,
            deleting: false,

            loadingLogs: false,
            logs: [],
        };
    },
    components: {
        Tabs,
        Error,
        StatusLog,
        AllInputFields
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.newsletterStore.setFormInitialized(false);
                this.initialize();
            }
        }
    },
    computed: {
        id() {
            return _.get(this.form, 'id', false);
        },
        status() {
            if (_.get(this.form, 'started_sending_at')) return 'sent'
            if (_.get(this.form, 'start_sending_at')) return 'planned'
            return 'draft'
        },
        hasBeenSent() {
            return this.status === 'sent'
        },
        isPlanned() {
            return this.status === 'planned'
        },
        canBeSent() {
            return this.status === 'draft' && !!this.id && this.form.subscriptionTopics && this.form.subscriptionTopics.length;
        },
        isDeletable() {
            return !!this.id && (this.status === 'draft' || this.status === 'planned');
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.deleting;
        },
        settings() {
            return _.get(this.activeCms, 'config.template.newsletter.settings') || []
        },
        sendModalRules() {
            // return {
            //     mode: 'required',
            //     timing: 'requiredIf:mode,production',
            //     scheduled_at: 'requiredIf:timing,scheduled',
            //     testRecipient: 'requiredIf:mode,test'
            // };

            let rules = {
                mode: 'required',
            };

            if (this.sendModal.form.mode === 'production') {
                rules.timing = 'required';
                if (this.sendModal.form.timing === 'scheduled') {
                    rules.scheduled_at = 'required';
                }
            } else if (this.sendModal.form.mode === 'test') {
                rules.testRecipients = 'required';
            }

            return rules;
        },
        sendModalScheduledAt: {
            get() {
                let scheduledAt = this.sendModal.form.scheduled_at
                if (scheduledAt) scheduledAt = appFromUnixTime(scheduledAt)
                return scheduledAt
            },
            set(value) {
                const scheduledAt = value !== null ? appGetUnixTime(value) : null
                this.sendModal.form.scheduled_at = scheduledAt
            }
        },
        // activeTab() {
        //     return _.replace(store.getters.activeTabKey, ':id', this.$route.params.id)
        // },
        tabs() {
            const id = this.$route.params.id;
            const name = _.get(this.form, 'subject') || this.$t('Newsletter');

            let tabs = [
                {
                    name,
                    path: `/marketing/newsletter/${id}/main`,
                    icon: {
                        name: 'newspaper',
                        group: 'far'
                    }
                },
                {
                    name: this.$t('Recipients & Schedule'),
                    path: `/marketing/newsletter/${id}/delivery`,
                    icon: {
                        name: 'envelope',
                        group: 'far'
                    }
                },
            ];

            if (this.settings) {
                tabs.push({
                    name: this.$t('Settings'),
                    path: `/marketing/newsletter/${id}/settings`,
                    icon: {
                        name: 'cog',
                        group: 'fas'
                    }
                })
            }

            return tabs;
        },
        user() {
            return useAuthStore().user;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        effectiveExtensions() {
            return useSetupStore().effectiveExtensions;
        },
        setupStore() {
            return useSetupStore()
        },
        pageStore() {
            return usePageStore()
        },
        page() {
            return this.pageStore.form;
        },
        newsletterStore() {
            return useNewsletterNewsletterStore();
        },
        form() {
            return this.newsletterStore.form;
        },
        options() {
            return this.newsletterStore.options;
        },
        initialized() {
            return this.newsletterStore.formInitialized;
        },
        validateOnEnter() {
            return this.newsletterStore.formValidateOnEnter;
        },
        rules() {
            return this.newsletterStore.rules;
        },
        previewShortcut() {
            return isApplePlatform() ? '⌘P' : 'Ctrl+P';
        },
        canShowPreview() {
            return !!this.id && !this.hasBeenSent;
        },
        senderEmailDomain() {
            var address = _.get(this.activeCms, 'newsletterSmtp.address', '');
            var parts = (address || '').split('@');
            return parts.length > 1 ? parts[1] : '';
        }
    },
    methods: {
        showSendModal() {
            this.sendModal.visibility = true;
            this.sendModal.form.testRecipients = [_.get(this.user, 'email') || _.get(this.activeCms, 'owner.user.email')]
            this.sendModal.form.testMemberSearch = ''
            this.sendModal.form.testMemberId = null
            this.sendModal.form.customSenderName = _.get(this.activeCms, 'newsletterSmtp.name', '')
            this.sendModal.form.customSenderAddressLocalPart = (_.get(this.activeCms, 'newsletterSmtp.address', '') || '').split('@')[0] || ''
            this.sendModal.formSnapshot = this.snapshotOf(this.sendModal.form)
        },
        async autocompleteMember(query, callback) {
            if (!query) return callback([])

            try {
                const members = await MemberApi.autocomplete(this.activeCms.id, query)
                callback(members || [])
            } catch (err) {
                console.error(err)
                callback([])
            }
        },
        selectTestMember(member) {
            this.sendModal.form.testMemberId = member.id
            this.sendModal.form.testMemberSearch = member.name
        },
        clearTestMember() {
            this.sendModal.form.testMemberId = null
            this.sendModal.form.testMemberSearch = ''
        },
        async sendNewsletter() {
            this.sendModal.sending = true;

            try {
                await this.submit()
            } catch (error) {
                this.sendModal.sending = false;
                return;
            }

            if (!isNumeric(this.id)) throw new Error('Newsletter ID is not valid');

            var variables = {
                id: parseInt(this.id),
                mode: this.sendModal.form.mode,
                timing: this.sendModal.form.timing,
                scheduled_at: this.sendModal.form.scheduled_at,
                testRecipients: this.sendModal.form.testRecipients
            };

            // Include testMember if a member is selected
            if (this.sendModal.form.testMemberId) {
                variables.testMember = { id: this.sendModal.form.testMemberId };
            }

            // Include custom sender fields if in production mode
            if (this.sendModal.form.mode === 'production') {
                variables.customSenderName = this.sendModal.form.customSenderName || null;
                variables.customSenderAddressLocalPart = this.sendModal.form.customSenderAddressLocalPart || null;
            }

            this.newsletterStore.send(variables)
                .then(() => {
                    this.closeSendModal();
                    this.$notify.success({
                        title: this.$t('Newsletter will be sent asynchronously'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(error => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(error);
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Newsletter could not be queued.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.sendModal.sending = false;
                })
        },
        closeSendModal() {
            this.sendModal.visibility = false;
        },
        resetSendModal() {
            this.sendModal = {
                visibility: false,
                size: '500px',
                title: this.$t('Send Newsletter'),
                form: {
                    mode: 'test', // possible values: 'test', 'production'
                    timing: 'immediate', // possible values: 'immediate', 'scheduled'
                    scheduled_at: null,
                    testRecipients: [_.get(this.user, 'email') || _.get(this.activeCms, 'owner.user.email')],
                    testMemberSearch: '',
                    testMemberId: null,
                    customSenderName: '',
                    customSenderAddressLocalPart: ''
                },
                rules: {
                    mode: 'required',
                    timing: 'required',
                    scheduled_at: 'requiredIf:timing,scheduled',
                },
                loading: false,
                error: false,
            };
        },
        showPreviewModal() {
            let sender = this.activeCms.name.trim();
            if (this.activeCms.newsletterSmtp) {
                sender = `${this.activeCms.newsletterSmtp.name || this.activeCms.name} <${this.activeCms.newsletterSmtp.username}>`.trim();
            }
            const recipient = 'Max Mustermann <max@mustermann.de>'

            const payload = {
                subject: this.form.subject,
                sender,
                recipients: [recipient],
                attachments: [],
            };
            this.$set(this.previewDrawer, 'data', payload);

            this.previewDrawer.title = this.$t('Email preview');
            this.previewDrawer.visibility = true;
            this.previewDrawer.loading = true;

            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe']

                const baseUrl = _.get(this.activeCms, 'domains.0.base_url');
                const url = _.get(this.activeCms, 'config.template.newsletter.render') || '{baseURL}/api/newsletter/{id}'

                // add src to iframe to load the preview
                // `http://127.0.0.1:4568/api/newsletter/${this.id}`
                let protocol = 'http:';
                if (process.env.NODE_ENV === 'production') protocol = window.location.protocol;

                let iframeSrc = url.replace('{baseURL}', `${protocol}//${baseUrl}`).replace('{id}', this.id);

                // Add no-cache parameter while preserving existing query parameters
                const urlObj = new URL(iframeSrc);
                urlObj.searchParams.set('no-cache', 'true');
                iframe.src = urlObj.toString();

                // console.log('>>>', iframe.src)
                // iframe.contentWindow.postMessage({
                //     type: 'UPDATE_DATA',
                //     payload: { user: 'John', timestamp: Date.now() }
                // }, '*'); // Replace '*' with specific origin for security
                this.previewDrawer.loading = false;
            })
        },
        closePreviewModal() {
            this.previewDrawer.visibility = false;
        },
        resetPreviewModal() {
            this.previewDrawer = {
                visibility: false,
                size: '700px',
                title: this.$t('Preview'),
                loading: false,
                error: false,
            };

            // const iframe = this.$refs['preview-iframe']
            // if (iframe) {
            //     iframe.contentWindow.document.open();
            //     iframe.contentWindow.document.write('');
            //     iframe.contentWindow.document.close();
            // }
        },
        handleKeyDown(event) {
            // Cmd+P (Mac) or Ctrl+P (Windows/Linux)
            if ((event.metaKey || event.ctrlKey) && event.key === 'p') {
                event.preventDefault();
                if (this.canShowPreview && !this.isDisabledSubmit) {
                    this.showPreviewModal();
                }
            }
        },
        async previewLoaded() {
            // this.refreshAuthentification();
            if (this.previewDrawer.data) {
                setTimeout(() => {
                    this.$set(this.previewDrawer, 'loading', false);
                }, 150)
            }
        },
        previewError(error) {
            this.$notify.error({
                title: this.$t('An error occurred!'),
                message: this.$t('Preview could not be rendered'),
                iconClass: 'fas el-icon-fa-times',
                position: 'bottom-left',
                customClass: 'dark',
                duration: 8000,
            })
        },

        initializeStatusLogSubscription() {
            if (!echo.client) {
                setTimeout(() => this.initializeStatusLogSubscription(), 10)
            } else {
                this.fetchRelatedStatusLogs();

                echo.client.private('cms.' + this.activeCms.id)
                    .listen('.status-log:created', async data => {
                        if (data.log && ['send-newsletter'].includes(data.log.key)) {
                            // check if log is already in the list
                            const exists = this.logs.find(log => parseInt(log.id) === parseInt(data.log.id));

                            // if not, fetch it and add it to the list
                            if (!exists) {
                                const logs = await StatusLogApi.fetchList({
                                    id: data.log.id,
                                    cms: parseInt(this.activeCms.id),
                                    status: [
                                        'info',
                                        'success',
                                        'warning',
                                        'error',
                                    ],
                                    key: [
                                        'send-newsletter',
                                    ],
                                    relation: {
                                        key: this.id,
                                        value: 'newsletter',
                                    },
                                    hide: false,
                                })
                                if (logs && logs.length) {
                                    this.logs = [...logs, ...this.logs]

                                    // order by created_at timestamp desc
                                    this.logs = _.orderBy(this.logs, 'created_at', 'desc')
                                    this.logs = _.uniqBy(this.logs, 'id');
                                }
                            }
                        }
                    })
                    .listen('.status-log:updated', async data => {
                        if (data.log && ['send-newsletter'].includes(data.log.key)) {
                            // find the log in the list
                            // and update it
                            const index = this.logs.findIndex(log => parseInt(log.id) === parseInt(data.log.id));

                            if (index >= 0) {
                                // this.$set(this.logs, index, data.log);
                                if (data.log.hide) {
                                    this.logs = this.logs.filter(log => parseInt(log.id) !== parseInt(data.log.id));
                                } else {
                                    this.$set(this.logs[index], 'status', data.log.status);
                                    this.$set(this.logs[index], 'progress', data.log.progress);
                                    this.$set(this.logs[index], 'updated_at', data.log.updated_at);
                                    this.$set(this.logs[index], 'heading', data.log.heading);
                                    this.$set(this.logs[index], 'body', data.log.body);
                                    this.$set(this.logs[index], 'data', data.log.data);
                                    this.$set(this.logs[index], 'hide', data.log.hide);

                                    this.$set(this.logs[index], 'file', data.log.file);
                                }
                            } else {
                                // if not found, fetch it and add it to the list
                                const logs = await StatusLogApi.fetchList({
                                    id: data.log.id,
                                    cms: parseInt(this.activeCms.id),
                                    status: [
                                        'info',
                                        'success',
                                        'warning',
                                        'error',
                                    ],
                                    key: [
                                        'send-newsletter',
                                    ],
                                    relation: {
                                        key: this.id,
                                        value: 'newsletter',
                                    },
                                    hide: false,
                                })
                                // if (logs && logs.length) {
                                //     // find the right place to insert the new log
                                //     const i = this.logs.findIndex(log => log.id > data.log.id)
                                //     if (i >= 0) this.logs.splice(i, 0, logs[0])
                                //     else this.logs.push(logs[0])
                                // }
                                if (logs && logs.length) {
                                    this.logs = [...logs, ...this.logs]

                                    // order by created_at timestamp desc
                                    this.logs = _.orderBy(this.logs, 'created_at', 'desc')
                                    this.logs = _.uniqBy(this.logs, 'id');
                                }
                            }
                        }
                    })
            }
        },
        fetchRelatedStatusLogs() {
            let variables = {
                cms: parseInt(this.activeCms.id),
                status: [
                    'info',
                    'success',
                    'warning',
                    'error',
                ],
                key: [
                    'send-newsletter',
                ],
                relation: {
                    key: this.id,
                    value: 'newsletter',
                },
                hide: false,
                skip: 0,
                take: 10,
            };

            StatusLogApi.fetchList(variables)
                .then((logs) => this.logs = logs)
                .catch(err => console.error(err));
        },
        hideStatusLog(log) {
            this.loadingLogs = true;

            log = _.cloneDeep(log);
            if (log.file) delete log.file
            log.hide = true;

            StatusLogApi.update(log)
                .then(data => {
                    // remove from list
                    if (data.hide) {
                        this.logs = this.logs.filter(el => el.id !== log.id);
                    } else {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Status log could not be hidden.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }
                })
                .catch(err => {
                    console.error(err)
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Status log could not be hidden.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.loadingLogs = false
                });
        },

        initialize() {
            if (!this.enabledExtensions.includes('newsletter')) {
                this.newsletterStore.setFormInitialized(true);
                return;
            }

            if (this.initialized !== true) {
                this.newsletterStore.setFormInitialized(true);

                let dependencies = []
                const fetchDependencies = () => {
                    dependencies = [
                        this.newsletterStore.fetchSubscriptionTopicOptions(this.activeCms.id),
                        this.fetchCategoryOptions(this.activeCms.id),
                        this.fetchMenuOptions(this.activeCms.id),
                        this.fetchTagOptions(this.activeCms.id),
                        this.fetchFileTagOptions(this.activeCms.id),
                    ];

                    // extensions
                    // fetch only if the corresponding extension is availible / active

                    if (this.enabledExtensions.includes('marketing') && checkRestrictions('ex:marketing')) {
                        dependencies.push(this.newsletterStore.fetchCampaignOptions(this.activeCms.id));
                    }
                    if (this.enabledExtensions.includes('event-manager') && checkRestrictions('ex:evnt')) {
                        dependencies.push(this.fetchEventCategoryOptions(this.activeCms.id));
                    }
                    if (this.enabledExtensions.includes('shop') && checkRestrictions('ex:shop')) {
                        dependencies.push(this.fetchShopCategoryOptions(this.activeCms.shop.id));
                        dependencies.push(this.fetchPropertyOptions(this.activeCms.shop.id));
                        dependencies.push(this.fetchShopTagOptions(this.activeCms.shop.id));
                        dependencies.push(this.fetchShopCustomerGroupOptions(this.activeCms.shop.id));
                        dependencies.push(this.newsletterStore.fetchCustomerGroupOptions(this.activeCms.shop.id));
                    }
                    if (this.effectiveExtensions.includes('restricted-area') && checkRestrictions('ex:rstrct||ex:shop')) {
                        dependencies.push(this.fetchRestrictedAreaMemberTagOptions(this.activeCms.id));
                    }

                    return Promise.allSettled(dependencies);
                };

                this.error = false;
                this.loading = true;

                const handleDependencyResults = function (results) {
                    var rejected = results.filter(function (result) {
                        return result.status === 'rejected';
                    });
                    if (rejected.length) {
                        rejected.forEach(function (result) {
                            // eslint-disable-next-line no-console
                            console.warn('Dependency fetch failed:', result.reason);
                        });
                    }
                };

                if (this.$route.params.id === 'new') {
                    this.newsletterStore.reset();
                    this.pageStore.reset();
                    // store.commit('ext_nwsltr_newsletter/resetRules')

                    // fetchDependencies().then(() => store.commit('ext_nwsltr_newsletter/updateRules', rules))
                    fetchDependencies()
                        .then(function (results) {
                            handleDependencyResults(results);
                            this.newsletterStore.initializeNewsletter();
                            setTimeout(this.$refs.form.clearValidate, 0)
                        }.bind(this))
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.newsletterStore.fetchNewsletter(this.$route.params.id)
                        .then((newsletter) => {
                            // store.commit('ext_nwsltr_newsletter/resetUI')

                            this.initializeStatusLogSubscription();

                            if (newsletter.page) {
                                this.insertPage(newsletter.page);
                            }

                            this.loading = false;

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(function (results) {
                                    handleDependencyResults(results);
                                    this.newsletterStore.resetRules();
                                    // store.commit('ext_nwsltr_newsletter/resetUI')
                                }.bind(this))
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Newsletter Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Newsletter could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    // console.log('else');
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                // console.log('is already initialized');
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        deleteCurrentNewsletter() {
            this.deleting = true;
            this.newsletterStore.deleteNewsletter(this.id)
                .then(() => {
                    // this.deleting = false

                    router.push(this.listRoute);

                    this.$notify.success({
                        title: this.$t('Newsletter deleted successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.deleting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Newsletter could not be deleted.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        async submit(event, redirect = false) {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate((valid, errors) => {
                    if (valid) {
                        if (redirect) this.savingAndClose = true;
                        else this.saving = true;

                        let save = this.newsletterStore.create.bind(this.newsletterStore);
                        if (this.id) save = this.newsletterStore.update.bind(this.newsletterStore);

                        const payload = {
                            ...this.form,
                            page: this.page
                        };

                        const isNewNewsletter = this.$route.params.id === 'new';

                        save(payload)
                            .then(() => {
                                if (redirect) this.savingAndClose = false;
                                else this.saving = false;

                                this.$notify.success({
                                    title: this.$t('Newsletter saved successfully!'),
                                    iconClass: 'fas el-icon-fa-check',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });

                                // Replace URL with new ID after creating a newsletter
                                if (isNewNewsletter && this.id) {
                                    const newPath = this.$route.path.replace('/new/', `/${this.id}/`);
                                    router.replace(newPath);
                                }

                                if (redirect) router.push(redirect);
                                else resolve();
                            })
                            .catch(err => {
                                /* eslint no-console: ["error", { allow: ["error"] }] */
                                console.error(err);

                                if (redirect) this.savingAndClose = false;
                                else this.saving = false;

                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Newsletter could not be saved.'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });

                                reject(err);
                            });
                    } else {
                        this.newsletterStore.setFormValidateOnEnter(true);

                        // check the invalid fields
                        // and go to the corresponding tab
                        // or open the corresponding closed area
                        // TODO: scroll to invalid field

                        let invalidTabs = [];
                        _.each(errors, (error, path) => {
                            if (_.indexOf(['subject'], path) >= 0) {
                                invalidTabs.push(`/marketing/newsletter/${this.$route.params.id}/main`);
                            }
                        });

                        invalidTabs = _.uniq(invalidTabs);

                        // check if the current tab
                        // is present in invalidTabs
                        // if not, go to next (first) invalid tab

                        const match = _.indexOf(invalidTabs, this.$route.fullPath);

                        // let switchTab = false;
                        if (match < 0) {
                            invalidTabs.every(invalidTab => {
                                if (invalidTab && this.activeTab !== invalidTab) {
                                    const tab = _.find(this.tabs, { path: invalidTab });
                                    if (tab) {
                                        this.activateTab(tab);

                                        // break loop after the first tab has been activated
                                        return false;
                                    }
                                }
                            });
                        }

                        // // triger the validation again
                        // // so the previously hidden fields will get the errors
                        // // ---
                        // // does not work if the component has been destroyed
                        // // in the meantime (f.a. by switching tabs)
                        // if (switchTab === false) {
                        //     const form = this.$refs.form
                        //     setTimeout(() => {
                        //         form.validate(() => {
                        //             // do nothing
                        //             // callback function is required :(
                        //         })
                        //     }, 1000);
                        // }

                        this.$notify.warning({
                            title: this.$t('Form is not valid!'),
                            message: this.$t('Correct your input and submit again.'),
                            iconClass: 'fas el-icon-fa-exclamation-circle',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });

                        reject()
                    }
                });
            })
        },
        leave() {
            router.push(this.listRoute);
        },
        activateTab(item) {
            return this.setupStore.activateTab(item)
        },
        insertPage(page) {
            return this.pageStore.insertPage(page);
        },
        fetchMenuOptions(cmsID) {
            return this.pageStore.fetchMenuOptions(cmsID);
        },
        fetchTagOptions(cmsID) {
            return this.pageStore.fetchTagOptions(cmsID);
        },
        fetchFileTagOptions(cmsID) {
            return this.pageStore.fetchFileTagOptions(cmsID);
        },
        fetchFilterOptions(payload) {
            return this.pageStore.fetchFilterOptions(payload);
        },
        fetchCategoryOptions(cmsID) {
            return this.pageStore.fetchCategoryOptions(cmsID);
        },
        // extensions
        fetchEventCategoryOptions(cmsID) {
            return this.pageStore.fetchEventManagerCategoryOptions(cmsID);
        },
        fetchShopCategoryOptions(shopID) {
            return this.pageStore.fetchShopCategoryOptions(shopID);
        },
        fetchPropertyOptions(shopID) {
            return this.pageStore.fetchShopPropertyOptions(shopID);
        },
        fetchShopTagOptions(shopID) {
            return this.pageStore.fetchShopTagOptions(shopID);
        },
        fetchShopCustomerGroupOptions(shopID) {
            return this.pageStore.fetchShopCustomerGroupOptions(shopID);
        },
        fetchRestrictedAreaMemberTagOptions(cmsID) {
            return this.pageStore.fetchRestrictedAreaMemberTagOptions(cmsID);
        }
    },
    mounted() {
        this.initialize();
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
    beforeRouteEnter(to, from, next) {
        // let cms = _.get(store, 'state.setup.activeCms')

        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new';

        if (to.name === 'newsletter-form') {
            next({ name: 'newsletter-main', params: { id } });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        setTimeout(() => {
            this.newsletterStore.reset();
            this.newsletterStore.resetUI();
            this.$nextTick(() => this.newsletterStore.resetRules());
        }, 300);

        setTimeout(() => {
            usePageStore(pinia).reset();
            usePageStore(pinia).resetUI();
            this.$nextTick(() => usePageStore(pinia).resetRules());
        }, 1000);
    },
    destroyed() {
        // console.log('destroyed');
    }
};
</script>

<style lang="sass" scoped>
.newsletter:deep()
    .el-card__body
        padding: 0
        & > section
            padding: 20px

.status-logs-container
    border-radius: 0
    margin-top: 0
    padding: 20px

.el-drawer__wrapper.email
    ::v-deep .el-drawer
        min-width: 600px
        max-width: 90%
        .el-form
            display: flex
            flex-direction: column
            .body
                position: relative
                flex-grow: 1
                width: 100%
        iframe,
        .preview
            // width: 100%
            // flex-grow: 1
            // max-height: calc(100vh - 135px)
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            max-width: 100%
            max-height: 100%
            overflow: auto
        .pill
            // padding: 2px 6px
            // background: #e2e2e2
            // margin: 2px
            // display: inline-block
            // border-radius: 3px
            &:not(:last-child):after
                content: ', '
                margin-right: 2px
        .from-to b + span.pill
            margin-left: 4px
        .meta
            padding: 20px
            padding-top: 0
            font-size: 0.8rem
            display: grid
            grid-template-rows: auto auto
            grid-template-columns: auto auto
            .subject
                grid-row: 2
                margin-top: 1rem
                b + span
                    margin-left: 4px
            .attachments
                grid-column: 2
                text-align: right
                display: flex
                flex-direction: column
                align-items: flex-end
                /* justify-content: flex-end */
                ul
                    // display: flex
                    // flex-wrap: wrap
                    // gap: 0.5rem
                    list-style: none
                    padding: 0
                    margin: 0

.autocomplete-item
    padding: 0.5rem 0
    line-height: 1.3
    .flex-row
        align-items: center

.test-member-hint
    font-size: 0.85em
    color: #909399
    line-height: 1.4

</style>
